import injectElement from './inject-element';
var SVGInjector = function (elements, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.afterAll, afterAll = _c === void 0 ? function () { return undefined; } : _c, _d = _b.afterEach, afterEach = _d === void 0 ? function () { return undefined; } : _d, _e = _b.beforeEach, beforeEach = _e === void 0 ? function () { return undefined; } : _e, _f = _b.cacheRequests, cacheRequests = _f === void 0 ? true : _f, _g = _b.evalScripts, evalScripts = _g === void 0 ? 'never' : _g, _h = _b.httpRequestWithCredentials, httpRequestWithCredentials = _h === void 0 ? false : _h, _j = _b.renumerateIRIElements, renumerateIRIElements = _j === void 0 ? true : _j;
    if (elements && 'length' in elements) {
        var elementsLoaded_1 = 0;
        for (var i = 0, j = elements.length; i < j; i++) {
            injectElement(elements[i], evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
                afterEach(error, svg);
                if (elements &&
                    'length' in elements &&
                    elements.length === ++elementsLoaded_1) {
                    afterAll(elementsLoaded_1);
                }
            });
        }
    }
    else if (elements) {
        injectElement(elements, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
            afterEach(error, svg);
            afterAll(1);
            elements = null;
        });
    }
    else {
        afterAll(0);
    }
};
export default SVGInjector;
//# sourceMappingURL=svg-injector.js.map